export default "__VITE_ASSET__mg_Dd0AS__"